/* eslint-disable no-unused-vars */
import {
    Box,
    Flex,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Text,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    useDisclosure,
    ModalHeader,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton,
} from '@chakra-ui/react';
import { userIcon } from '../components/Icons';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useCustomers } from 'hooks/useCustomers';
import { BsEye, BsThreeDotsVertical } from 'react-icons/bs';
import CreateReportForm from './CreateReportForm';
import CustomerReports from './CustomerReports';
import { MdNotes } from 'react-icons/md';
import useGetUserDetails from 'hooks/useGetUserDetail';
import CreateCustomerModal from './CreateCustomerModal';

const Customer = () => {
    const { fetchCustomers, customers, isLoading } = useCustomers();
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedReport, setSelectedReport] = useState(null);
    const [modalMode, setModalMode] = useState(null);
    const [refreshReports, setRefreshReports] = useState(0);
    const [showCreateCustomer, setShowCreateCustomer] = useState(false);

    const { isOpen, onClose, onOpen } = useDisclosure();
    const { flattenedUser: details } = useGetUserDetails();

    const loggedInSalesPerson = details?.attributes
        ? {
              sales_person_id:
                  details.attributes.sales_person_id || details.attributes.zoho_id || '',
              first_name: details.attributes.first_name || '',
              last_name: details.attributes.last_name || '',
              displayName: `${details.attributes.first_name || ''} ${
                  details.attributes.last_name || ''
              }`.trim(),
          }
        : null;

    useEffect(() => {
        fetchCustomers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleMenuAction = (customer, action) => {
        setSelectedCustomer(customer);
        setModalMode(action);
        setSelectedReport(null);
        onOpen();
    };

    const handleModalClose = () => {
        onClose();
        setSelectedCustomer(null);
        setModalMode(null);
        setSelectedReport(null);
    };

    const handleReportSuccess = () => {
        handleModalClose();
        setRefreshReports((prev) => prev + 1);
    };

    const handleEditReport = (report) => {
        setSelectedReport(report);
        setModalMode('edit');
    };

    const handleCustomerCreated = () => {
        fetchCustomers();
    };

    return (
        <Box>
            <Box
                display={'flex'}
                flexDir={{ base: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={{ md: 'center' }}
                gap={3}>
                <Flex gap="2" alignItems={'center'} color={'#1B3B5F'} fontWeight={'500'}>
                    {userIcon}
                    <Text fontSize={{ base: 'lg', lg: 'xl' }}>CUSTOMER OVERVIEW</Text>
                </Flex>

                <Button
                    size="sm"
                    bg="#1B3B5F"
                    color="white"
                    fontWeight={600}
                    borderRadius="8px"
                    px={5}
                    _hover={{ bg: '#16a34a', transform: 'translateY(-1px)', boxShadow: 'md' }}
                    _active={{ transform: 'translateY(0)' }}
                    transition="all 0.18s"
                    leftIcon={
                        <Text fontSize="15px" lineHeight="1" mt="-1px">
                            +
                        </Text>
                    }
                    onClick={() => setShowCreateCustomer(true)}>
                    Add Customer
                </Button>
            </Box>

            {!customers || isEmpty(customers) ? (
                <Box
                    minH={'40vh'}
                    display={'flex'}
                    flexDir="column"
                    justifyContent={'center'}
                    alignItems={'center'}
                    gap={3}
                    color={'#667085'}>
                    <Text fontSize="sm">No customers assigned to you yet.</Text>
                    <Button
                        size="sm"
                        variant="outline"
                        borderColor="#1B3B5F"
                        color="#1B3B5F"
                        _hover={{ bg: '#1B3B5F', color: 'white' }}
                        onClick={() => setShowCreateCustomer(true)}>
                        + Create your first customer
                    </Button>
                </Box>
            ) : (
                <Box mt="5">
                    <TableContainer border="1px solid #EAECF0" borderRadius="lg">
                        <Table variant="simple" size="sm">
                            <Thead bg={'#F9FAFB'}>
                                <Tr>
                                    <Th textAlign={'center'} py="4">
                                        Customer Name
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Email
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Phone
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Total Orders
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Total Spent
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Last Order Date
                                    </Th>
                                    <Th textAlign={'center'} py="4">
                                        Actions
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {customers?.map((customer, i) => (
                                    <Tr
                                        key={i}
                                        _hover={{ bg: '#F9FAFB' }}
                                        transition="background 0.12s">
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            <Text fontWeight={500} color="#1B3B5F">
                                                {customer.customer_name ||
                                                    customer.contact_name ||
                                                    '-'}
                                            </Text>
                                        </Td>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {customer.email ? (
                                                <Text
                                                    as="a"
                                                    fontWeight="medium"
                                                    color="#2563EB"
                                                    textDecoration={'underline'}
                                                    href={`mailto:${customer.email}`}
                                                    target="_blank">
                                                    {customer.email}
                                                </Text>
                                            ) : (
                                                '-'
                                            )}
                                        </Td>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {customer.phone ? (
                                                <Text
                                                    as="a"
                                                    fontWeight="medium"
                                                    color="#2563EB"
                                                    textDecoration={'underline'}
                                                    href={`tel:${customer.phone}`}
                                                    target="_blank">
                                                    {customer.phone}
                                                </Text>
                                            ) : (
                                                '-'
                                            )}
                                        </Td>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {customer.totalOrders || '-'}
                                        </Td>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {customer.totalSpent || '-'}
                                        </Td>
                                        <Td
                                            borderRight="1px solid #EAECF0"
                                            py="4"
                                            textAlign={'center'}>
                                            {customer.lastOrderDate || '-'}
                                        </Td>
                                        <Td py="4" textAlign={'center'}>
                                            <Menu>
                                                <MenuButton
                                                    as={IconButton}
                                                    icon={<BsThreeDotsVertical />}
                                                    variant="ghost"
                                                    size="sm"
                                                    aria-label="Options"
                                                    color="#1B3B5F"
                                                    _hover={{ bg: '#F0F7FF' }}
                                                    _active={{ bg: '#EAECF0' }}
                                                />
                                                <MenuList
                                                    minW="180px"
                                                    boxShadow="lg"
                                                    border="1px solid #EAECF0"
                                                    borderRadius="md"
                                                    py={2}>
                                                    <MenuItem
                                                        onClick={() =>
                                                            handleMenuAction(customer, 'view')
                                                        }
                                                        icon={
                                                            <Box as="span" fontSize="18px">
                                                                <BsEye />
                                                            </Box>
                                                        }
                                                        _hover={{ bg: '#F0F7FF', color: '#2563EB' }}
                                                        py={3}
                                                        fontWeight="500">
                                                        View Reports
                                                    </MenuItem>
                                                    <MenuItem
                                                        onClick={() =>
                                                            handleMenuAction(customer, 'create')
                                                        }
                                                        icon={
                                                            <Box as="span" fontSize="18px">
                                                                <MdNotes />
                                                            </Box>
                                                        }
                                                        _hover={{ bg: '#F0F7FF', color: '#2563EB' }}
                                                        py={3}
                                                        fontWeight="500">
                                                        Create Report
                                                    </MenuItem>
                                                </MenuList>
                                            </Menu>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>
            )}

            <Modal size={'lg'} isOpen={isOpen} onClose={handleModalClose}>
                <ModalOverlay />
                <ModalContent borderRadius="lg" maxW={{ base: '95vw', md: '60vw' }}>
                    <ModalHeader
                        textAlign="center"
                        fontSize={{ base: 'lg', md: 'xl' }}
                        fontWeight="bold"
                        color="#1B3B5F">
                        {modalMode === 'view'
                            ? `Reports for ${
                                  selectedCustomer?.customer_name || selectedCustomer?.contact_name
                              }`
                            : `Create Report for ${
                                  selectedCustomer?.customer_name || selectedCustomer?.contact_name
                              }`}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        {modalMode === 'view' && selectedCustomer && (
                            <CustomerReports
                                customer={selectedCustomer}
                                refreshTrigger={refreshReports}
                                onEdit={handleEditReport}
                            />
                        )}
                        {(modalMode === 'create' || modalMode === 'edit') && selectedCustomer && (
                            <CreateReportForm
                                customer={selectedCustomer}
                                initialData={modalMode === 'edit' ? selectedReport : null}
                                isEdit={modalMode === 'edit'}
                                onCancel={handleModalClose}
                                onSuccess={handleReportSuccess}
                            />
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

            {showCreateCustomer && (
                <CreateCustomerModal
                    onClose={() => setShowCreateCustomer(false)}
                    onSuccess={handleCustomerCreated}
                    loggedInSalesPerson={loggedInSalesPerson}
                />
            )}
        </Box>
    );
};

export default Customer;
